import { Typography, useTheme } from "@mui/material";
import React from "react";

const Title = ({
    label,
    textAlign = undefined,
    variant = "h1",
    fontWeight = undefined,
    fullWidth = false,
    pt = undefined,
    pb = 2,
    pl = undefined,
}) => {
    const theme = useTheme();
    const borderWidth = variant === "h1" ? "10px" : (variant === "h2" ? "6px" : "2px");

    return (
        <Typography
            variant={variant}
            textAlign={textAlign}
            width={fullWidth ? "100%" : undefined}
            sx={{
                display: 'inline-block',
                fontWeight: {fontWeight},
                paddingTop: Boolean(pt) ? theme.spacing(pt) : undefined,
                paddingBottom: Boolean(pb) ? theme.spacing(pb) : undefined,
                paddingLeft: Boolean(pl) ? theme.spacing(pl) : undefined,
                borderBottom: `${borderWidth} solid ${theme.palette.primary.main}`,
            }}
        >
            {label}
        </Typography>
    );
}

export default Title;
